// src/pages/SuperAdminDashboard.jsx
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import SuperAdminPanel from "../panel/SuperAdminPanel";
import api from "../../../api/api";
import "../styles/SuperAdminDashboard.css";

const SuperAdminDashboard = () => {
  const { superAdminId } = useParams();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // ✅ Form state
  const [schoolName, setSchoolName] = useState("");
  const [address, setAddress] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  // ✅ Handle form submit
  const handleCreateSchoolAdmin = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const res = await api.post("/api/superadmin/create-school-admin", {
          schoolName,
          address,
          contact,
          adminEmail: email,
          adminPassword: password,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setMessage(res.data.message);
      setSchoolName("");
      setAddress("");
      setContact("");
      setEmail("");
      setPassword("");
    } catch (err) {
      console.error("❌ Error creating school & admin:", err.response?.data || err.message);
      setMessage(err.response?.data?.error || "Failed to create school and admin");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SuperAdminPanel onToggle={setIsSidebarCollapsed} />

      <div className={`superadmin-main-content ${isSidebarCollapsed ? "collapsed" : ""}`}>
        {/* ✅ Topbar */}
        <div className="superadmin-topbar">
          <span className="superadmin-date">TODAY IS {new Date().toLocaleString()}</span>
          <span className="superadmin-school">School ERP</span>
        </div>

        <h2 className="superadmin-welcome">Welcome, Super Admin!</h2>

        {/* ✅ Cards */}
        <div className="superadmin-cards">
          <div className="superadmin-card">Total Teachers: 50</div>
          <div className="superadmin-card">Total Students: 200</div>
          <div className="superadmin-card">Pending Requests: 5</div>
          <div className="superadmin-card">Notifications: 3</div>
        </div>

        {/* ✅ Create School + Admin Form */}
        <div className="superadmin-section">
          <h3>Create School & Admin</h3>
          <form
            onSubmit={handleCreateSchoolAdmin}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              maxWidth: "400px",
            }}
          >
            <input
              type="text"
              placeholder="School Name"
              value={schoolName}
              onChange={(e) => setSchoolName(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
            <input
              type="text"
              placeholder="Contact"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
            />
            <hr />
            <input
              type="email"
              placeholder="Admin Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Admin Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="submit"
              disabled={loading}
              style={{ padding: "10px", background: "#5c3dc4", color: "#fff" }}
            >
              {loading ? "Creating..." : "Create School & Admin"}
            </button>
          </form>
          {message && <p style={{ marginTop: "15px" }}>{message}</p>}
        </div>

        {/* ✅ Recent Activities */}
        <div className="superadmin-section">
          <h3>Recent Activities</h3>
          <ul className="superadmin-activities">
            <li>Teacher Rahul Sharma added a new class.</li>
            <li>Student Priya Mehta submitted homework.</li>
            <li>Admin John updated timetable.</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default SuperAdminDashboard;
